import { render, staticRenderFns } from "./TheLayoutFrame.vue?vue&type=template&id=2153496f&"
import script from "./TheLayoutFrame.vue?vue&type=script&lang=js&"
export * from "./TheLayoutFrame.vue?vue&type=script&lang=js&"
import style0 from "./TheLayoutFrame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TheLayoutFrame.vue"
export default component.exports